import React from 'react';
import { Box, Typography } from '@mui/material';
import { People, WorkOutline, DescriptionOutlined } from '@mui/icons-material';
import { styled } from '@mui/material/styles';

const StatsRow = styled(Box)`
    display: flex;
    justify-content: center;
    gap: 0;
    background: linear-gradient(135deg,
        ${props => props.theme.palette.primary.main} 0%,
        ${props => props.theme.palette.primary.light} 100%
    );
    border-radius: 1rem;
    overflow: hidden;
    box-shadow: 0 8px 32px ${props => props.theme.palette.primary.main}40;

    ${props => props.theme.breakpoints.down('sm')} {
        flex-direction: column;
        border-radius: 0.75rem;
    }
`;

const StatDivider = styled(Box)`
    width: 1px;
    background: rgba(255, 255, 255, 0.25);
    align-self: stretch;
    flex-shrink: 0;
    margin-block: 1.25rem;

    ${props => props.theme.breakpoints.down('sm')} {
        width: auto;
        height: 1px;
        margin-block: 0;
        margin-inline: 1.5rem;
    }
`;

const StatItem = styled(Box)`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 1.75rem 1rem;
    color: white;

    ${props => props.theme.breakpoints.down('sm')} {
        flex-direction: row;
        gap: 1rem;
        padding: 1rem 1.5rem;
        justify-content: flex-start;
    }
`;

const STATS = [
    { icon: <People sx={{ fontSize: '2.25rem' }} />, value: '200,000+', label: 'כניסות של מועמדים בחודש' },
    { icon: <WorkOutline sx={{ fontSize: '2.25rem' }} />, value: 'מעל 3,000', label: 'מעסיקים מוצגים' },
    { icon: <DescriptionOutlined sx={{ fontSize: '2.25rem' }} />, value: 'אלפי', label: 'קורות חיים נשלחים כל יום' },
];

const ElpStats = (): JSX.Element => (
    <StatsRow>
        {STATS.map((stat, i) => (
            <React.Fragment key={stat.label}>
                {i > 0 && <StatDivider />}
                <StatItem>
                    <Box sx={{ opacity: 0.75, display: 'flex', mb: { xs: 0, sm: 0.5 } }}>
                        {stat.icon}
                    </Box>
                    <Box textAlign={{ xs: 'right', sm: 'center' }}>
                        <Typography fontWeight={800} fontSize="1.875rem" lineHeight={1.1} color="white">
                            {stat.value}
                        </Typography>
                        <Typography variant="body2" sx={{ opacity: 0.85 }} color="white" mt={0.25}>
                            {stat.label}
                        </Typography>
                    </Box>
                </StatItem>
            </React.Fragment>
        ))}
    </StatsRow>
);

export default ElpStats;
